<div class="payment-sip-wrapper">

  <div *ngIf="config?.page==='f' && config?.enable_multicause_slab" class="multicause-slab">
    <app-component-loader [load]="true" selector="app-multicause-slab" [inputs]="{config: config}" [outputs]="{currencyChange: getPaymentDetails, formSubmitted: getPaymentOptions}" />
  </div>

  <!-- Payment Form -->
  <app-payment-sip-form *ngIf="config?.page==='f' && !config?.enable_multicause_slab" [config]="config"
                        (setCurrency)="getPaymentDetails($event)"
                        (dataEmit)="intiatePayment($event)"
                        (formSubmitted)="getPaymentOptions()">
  </app-payment-sip-form>

  <!-- Payment Options -->
  <app-payment-sip-options *ngIf="config?.page==='op'" [config]="config"
                          (dataEmit)="intiatePayment($event)" (paySwitchEmit)="getPaymentOptions()">
  </app-payment-sip-options>
</div>


<!-- Captcha -->
<app-g-captcha (dataEmit)="captchaResponse($event)"></app-g-captcha>


<!-- One tap otp confrimation -->
<app-module-loader moduleId="otp-confirmation" selector="app-otp-confirmation"
                  [load]="oneTapOtpPopup"
                  [outputs]="{ verified: otpVerified }">
</app-module-loader>